import React, { useState } from 'react';
import { ArrowRight, Check, ChevronLeft, ChevronRight, Package, ShieldCheck } from 'lucide-react';
const CAROUSEL_IMAGES = [{
  url: 'https://cdn.magicpatterns.com/uploads/fULNuJtnKKba2Q6BDD1WbW/Cover_SIC_360.png',
  alt: 'SIC 360'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/3thPi5qdLtm9q4pLEKBxYU/conver_micro_y_macro.png',
  alt: 'Micro y Macro Economía 360'
}, {
  url: 'https://cdn.magicpatterns.com/uploads/ragupa4ejf4oGHNE87TryE/ChatGPT_Image_11_ene_2026,_07_34_47_p.m..png',
  alt: '100 Micro-Emprendimientos Ganadores'
}];
export function UpsellSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % CAROUSEL_IMAGES.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + CAROUSEL_IMAGES.length) % CAROUSEL_IMAGES.length);
  };
  return <section className="py-16 bg-gradient-to-b from-blue-900 to-blue-950 relative overflow-hidden" data-id="element-247">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-248"></div>

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-249">
        {/* Main Upsell Card with Animated Border */}
        <div className="relative" data-id="element-250">
          {/* Animated Glowing Border - NO ROTATION */}
          <div className="absolute -inset-1 bg-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400 rounded-3xl blur-lg opacity-75 animate-pulse" data-id="element-251"></div>

          {/* Main Card Content */}
          <div className="relative bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-yellow-400" data-id="element-252">
            {/* Premium Badge Button */}
            <div className="px-8 pt-8 pb-6 text-center border-b border-slate-100" data-id="element-253">
              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-orange-600 text-white font-bold px-6 py-3 rounded-full shadow-lg text-sm mb-6 uppercase tracking-wide" data-id="element-254">
                <span data-id="element-255">🔥 OFERTA ESPECIAL - PACK FULL</span>
              </div>

              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-4 leading-tight" data-id="element-256">
                Llevate TODO el Sistema 360
              </h2>

              <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed" data-id="element-257">
                SIC 360, Micro y Macro Economía 360 + 100 ideas reales de
                emprendimientos para trabajar con alumnos de último año
              </p>
            </div>

            {/* Carousel Section */}
            <div className="bg-gradient-to-br from-blue-50 to-white p-8 border-b-4 border-yellow-400 relative" data-id="element-258">
              <div className="relative max-w-md mx-auto" data-id="element-259">
                {/* Carousel Images */}
                <div className="relative overflow-hidden rounded-lg shadow-xl" data-id="element-260">
                  <div className="flex transition-transform duration-500 ease-out" style={{
                  transform: `translateX(-${currentSlide * 100}%)`
                }} data-id="element-261">
                    {CAROUSEL_IMAGES.map((image, index) => <div key={index} className="min-w-full" data-id="element-262">
                        <img src={image.url} alt={image.alt} className="w-full h-auto" data-id="element-263" />
                      </div>)}
                  </div>
                </div>

                {/* Carousel Controls */}
                <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all z-10" aria-label="Anterior" data-id="element-264">
                  <ChevronLeft className="w-6 h-6 text-blue-900" data-id="element-265" />
                </button>
                <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white p-2 rounded-full shadow-lg transition-all z-10" aria-label="Siguiente" data-id="element-266">
                  <ChevronRight className="w-6 h-6 text-blue-900" data-id="element-267" />
                </button>

                {/* Carousel Dots */}
                <div className="flex justify-center gap-2 mt-4" data-id="element-268">
                  {CAROUSEL_IMAGES.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full transition-all ${currentSlide === index ? 'bg-blue-600 w-8' : 'bg-blue-300 hover:bg-blue-400'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-269" />)}
                </div>
              </div>
            </div>

            {/* Pricing */}
            <div className="px-8 pt-8 pb-6 text-center border-b border-slate-100" data-id="element-270">
              <p className="text-slate-400 uppercase tracking-wider text-sm font-bold mb-2" data-id="element-271">
                Precio Pack Completo
              </p>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-272">
                <span className="text-slate-400 text-2xl font-bold line-through" data-id="element-273">
                  $69.990
                </span>
                <span className="text-blue-900 text-5xl md:text-6xl font-black" data-id="element-274">
                  $39.990
                </span>
              </div>
              <p className="text-green-600 font-bold bg-green-50 inline-block px-4 py-1 rounded-full text-sm" data-id="element-275">
                Ahorrás $30.000 con el pack completo
              </p>
            </div>

            {/* Benefits List */}
            <div className="px-8 py-6 space-y-4" data-id="element-276">
              {/* Benefit 1 */}
              <div className="bg-green-50 rounded-xl p-4 border border-green-100" data-id="element-277">
                <div className="flex items-start gap-3" data-id="element-278">
                  <div className="bg-green-500 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-279">
                    <Check className="w-4 h-4 text-white" data-id="element-280" />
                  </div>
                  <div data-id="element-281">
                    <h3 className="font-bold text-slate-900 mb-1" data-id="element-282">
                      Sistema Completo SIC 360
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-283">
                      Clases estructuradas para todo el año lectivo con ejemplos
                      argentinos actuales
                    </p>
                  </div>
                </div>
              </div>

              {/* Benefit 2 */}
              <div className="bg-orange-50 rounded-xl p-4 border border-orange-100" data-id="element-284">
                <div className="flex items-start gap-3" data-id="element-285">
                  <div className="bg-green-500 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-286">
                    <Check className="w-4 h-4 text-white" data-id="element-287" />
                  </div>
                  <div data-id="element-288">
                    <h3 className="font-bold text-slate-900 mb-1" data-id="element-289">
                      4 Bonos Exclusivos (Gratis por hoy)
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-290">
                      Banco de ejemplos, clases express, evaluaciones listas y
                      mapa anual de contenidos
                    </p>
                  </div>
                </div>
              </div>

              {/* Benefit 3 */}
              <div className="bg-blue-50 rounded-xl p-4 border border-blue-100" data-id="element-291">
                <div className="flex items-start gap-3" data-id="element-292">
                  <div className="bg-green-500 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-293">
                    <Check className="w-4 h-4 text-white" data-id="element-294" />
                  </div>
                  <div data-id="element-295">
                    <h3 className="font-bold text-slate-900 mb-1" data-id="element-296">
                      Acceso Inmediato y Vitalicio
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-297">
                      Descargá todo el material al instante y accedé cuando lo
                      necesites, sin vencimiento
                    </p>
                  </div>
                </div>
              </div>

              {/* NEW Benefit 4 - EXTRA */}
              <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl p-4 border-2 border-yellow-400 relative overflow-hidden" data-id="element-298">
                <div className="absolute top-0 right-0 bg-yellow-400 text-blue-900 text-xs font-black px-3 py-1 rounded-bl-lg" data-id="element-299">
                  EXTRA
                </div>
                <div className="flex items-start gap-3" data-id="element-300">
                  <div className="bg-yellow-500 rounded-full p-1 flex-shrink-0 mt-0.5" data-id="element-301">
                    <Check className="w-4 h-4 text-white" data-id="element-302" />
                  </div>
                  <div data-id="element-303">
                    <h3 className="font-bold text-slate-900 mb-1" data-id="element-304">
                      MICRO Y MACRO ECONOMÍA 360 + 100 MICRO-EMPRENDIMIENTOS
                      GANADORES
                    </h3>
                    <p className="text-sm text-slate-600" data-id="element-305">
                      El pack completo de micro y macro economía 360 + 100 ideas
                      reales de emprendimientos para trabajar con alumnos de
                      último año
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="px-8 pb-8" data-id="element-306">
              <a href="https://checkout.rincondigital.shop/cart/52917897363731:1" className="block w-full bg-gradient-to-r from-yellow-500 via-orange-500 to-orange-600 hover:from-yellow-600 hover:via-orange-600 hover:to-orange-700 text-white font-black py-5 px-6 rounded-2xl shadow-lg transform transition hover:-translate-y-1 text-center text-lg group relative overflow-hidden" data-id="element-307">
                <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-308">
                  ACCEDÉ AL PACK FULL
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-309" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-yellow-600 via-orange-600 to-orange-700 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-310"></div>
              </a>

              {/* Trust Badges */}
              <div className="flex items-center justify-center gap-6 mt-6 text-slate-500 text-xs" data-id="element-311">
                <div className="flex items-center gap-1" data-id="element-312">
                  <ShieldCheck className="w-4 h-4" data-id="element-313" />
                  <span data-id="element-314">Compra Segura</span>
                </div>
                <div className="flex items-center gap-1" data-id="element-315">
                  <Package className="w-4 h-4" data-id="element-316" />
                  <span data-id="element-317">Material Digital</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}